import { makeStyles } from 'tss-react/mui';

/**
 * Cell height constraints:
 * - tallHeight: 890px (positions 1, 4)
 * - shortHeight: 400px (positions 2, 3)
 * - mobile: 500px per cell (image ~460px + info from mobileTeaser/mobileHeight)
 */
export default makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  bottomPadding: {
    paddingBottom: theme.spacing(2),
  },
  /**
   * On mobile, columns stack (cards 1–2 then 3–4). Card 1 uses `bottomPadding` before card 2;
   * without this, card 2 sat flush against card 3 at the column break.
   */
  bottomPaddingMobileOnly: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  rightPadding: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
    paddingRight: theme.spacing(2),
  },
  // Cell wrappers so PostCard (variant="featured") fills parent and image area gets correct proportion
  cellTall: {
    height: '890px',
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      height: '500px',
    },
  },
  cellShort: {
    height: '400px',
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      height: '500px',
    },
  },
  skeletonLeft: {
    margin: theme.spacing(0, 3, 3, 0),
    height: '100%',
    minHeight: 0,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0, 0, 1, 0),
    },
  },
  skeletonRight: {
    margin: theme.spacing(0, 0, 3, 0),
    height: '100%',
    minHeight: 0,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0, 0, 1, 0),
    },
  },
  // Card-shaped skeleton: image area + content area to match PostCard layout
  skeletonCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  skeletonImage: {
    flex: 1,
    minHeight: 0,
  },
  skeletonContent: {
    flexShrink: 0,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));
